<div class="form-group">
    <label *ngIf="title">{{title}} {{controlArray | controlRequiredText}}
        <i class="pj-ico pj-ico-ayuda-info text-primary" [ngClass]="{'d-none':!popoverContent}" data-toggle="popover"
            data-placement="top" data-html="true" data-trigger="hover" [attr.data-content]="popoverContent"
            tabindex="0">
        </i>
    </label>

    <div [class.disabled]="controlArray.disabled" [class.dropdown-lg]="size === 'lg'"
        [class.dropdown-one-line-txt-btn]="!showValuesOnPlaceholder"
        class="dropdown dropdown-filter dropdown-input-filter   " [id]="id + '-dp'">
        <button [class.data-required]="controlArray.touched && controlArray.invalid"
            class="btn dropdown-toggle dropdown-toggle-no-arrow" type="button" [id]="id" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <ng-container *ngIf="countSelectedValues === 0 || !showValuesOnPlaceholder">
                {{placeholderTextSelected || placeholder}}
            </ng-container>

            <ng-container *ngIf="showValuesOnPlaceholder">
                <ng-container *ngFor="let parent of controlArray.controls ; let i = index">
                    <ng-container *ngFor="let child of parent.controls;  let j = index">
                        <div *ngIf="child.value===true" class="selection-choice">
                            {{dataSelect[i].items[j].child}} <a (click)="onRemoveOption($event,i, j)"
                                class="selection-choice-remove" title="Eliminar">×</a>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container> &nbsp;

        </button>
        <div class="dropdown-menu dropdown-menu-filter dropdown-input-tag-collapse ">
            <div class="mgn-bottom-10">
                <label [for]="id + '-search'" class="accesibleHidden">{{placeholderSearch}}</label>
                <input type="text" class="form-control filter-input" [id]="id + '-search'"
                    [placeholder]="placeholderSearch" />
            </div>

            <div class="no-result-ctn d-none">
                <label>No se encontraron resultados</label>
            </div>

            <div class="mgn-bottom-10 collapsable-item" *ngIf="control">
                <label class="checkbox-label mgn-rigth-12" [for]="controlId">
                    <input class="excluded-filter" type="checkbox" [id]="controlId" name="" [formControl]="control" />
                    <span class="checkmark"></span>
                    {{controlText}}
                </label>
            </div>

            <hr class="hr-dropdown collapsable-item" *ngIf="control" />

            <div class="collapse-fieldset-group">


                <ng-container *ngFor="let parent of controlArray.controls ; let i = index">

                    <div class="collapse-fieldset">

                        <div class="fieldset-header group-heading">
                            <a data-toggle="collapse" href=""><i
                                    class="pj-ico pj-ico-flecha-colapsable"></i>{{dataSelect[i].parent}}</a>
                        </div>
                        <div class="fieldset-body show">

                            <div class="checkbox-group">

                                <div class="wrap-checkbox excluded" [class.d-none]="!textSelectAllGroup">
                                    <label class="checkbox-label every-checkbox" [for]="id + '-all-' + i">
                                        <input class="every-check" type="checkbox" [id]="id + '-all-' + i"
                                            (change)="onChangeCheckboxAll($event, i)" />
                                        <span class="checkmark"></span>
                                        {{textSelectAllGroup}}
                                    </label>
                                </div>

                                <div class="wrap-checkbox" *ngFor="let child of parent.controls;  let j = index">
                                    <label class="checkbox-label" [for]="id + '-' + i + '-' + j">
                                        <input class="custom-single-check" type="checkbox" [id]="id + '-' + i + '-' + j"
                                            (change)="onChangeCheckbox($event, i, j)" [formControl]="child" />
                                        <span class="checkmark"></span>
                                        {{dataSelect[i].items[j].child}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div-validation-message [control]="controlArray" [messageRequired]="messageRequired"></div-validation-message>

    <small *ngIf="footer" class="form-text text-muted" [innerHTML]="footer"></small>
</div>